module.exports = __webpack_public_path__ + "img/img2.ae40a0b0.png";